"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _isEmpty = require("lodash/isEmpty");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _formActionUtils = require("egov-ui-kit/utils/PTCommon/FormWizardUtils/formActionUtils");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconStyle = {
  marginRight: "13px",
  height: "24px",
  width: "24px"
};

var imageStyles = {
  maxHeight: "100px",
  minHeight: "100px"
};

var mapIconStyle = {
  marginRight: "7px",
  height: "12px",
  width: "14px",
  borderRadius: "50%"
};

var Details = function (_Component) {
  (0, _inherits3.default)(Details, _Component);

  function Details() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Details);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Details.__proto__ || Object.getPrototypeOf(Details)).call.apply(_ref, [this].concat(args))), _this), _this.navigateToComplaintType = function () {
      _this.props.history.push("/complaint-type");
    }, _this.onImageClick = function (source) {
      _this.props.history.push("/image?source=" + source);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Details, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          status = _props.status,
          complaint = _props.complaint,
          subCategory = _props.subCategory,
          category = _props.category,
          applicationNo = _props.applicationNo,
          description = _props.description,
          fullName = _props.fullName,
          phone = _props.phone,
          source = _props.source,
          submittedDate = _props.submittedDate,
          servicetype = _props.servicetype,
          prevDept = _props.prevDept,
          addressDetail = _props.addressDetail,
          mapAction = _props.mapAction,
          images = _props.images,
          action = _props.action,
          role = _props.role;

      var _ref2 = addressDetail || "",
          houseNoAndStreetName = _ref2.houseNoAndStreetName,
          _ref2$premise = _ref2.premise,
          premise = _ref2$premise === undefined ? "" : _ref2$premise,
          _ref2$pincode = _ref2.pincode,
          pincode = _ref2$pincode === undefined ? "" : _ref2$pincode,
          _ref2$ward = _ref2.ward,
          ward = _ref2$ward === undefined ? "" : _ref2$ward,
          _ref2$address = _ref2.address,
          address = _ref2$address === undefined ? "" : _ref2$address,
          _ref2$streetName = _ref2.streetName,
          streetName = _ref2$streetName === undefined ? "" : _ref2$streetName,
          _ref2$residenceAddres = _ref2.residenceAddress,
          residenceAddress = _ref2$residenceAddres === undefined ? "" : _ref2$residenceAddres,
          _ref2$landmark = _ref2.landmark,
          landmark = _ref2$landmark === undefined ? "" : _ref2$landmark,
          mohalla = _ref2.mohalla,
          city = _ref2.city,
          locality = _ref2.locality;

      var icon = {};
      icon.name = "location";
      icon.style = {
        display: "block"
      };
      var statusKey = "";

      if (status) {
        if (status.toLowerCase() == "open") {
          if (action && action === "reopen") {
            statusKey = "Re-opened";
          } else {
            statusKey = "Open";
          }
        } else if (status.toLowerCase() == "reassignrequested") {
          if (role === "citizen") {
            statusKey = "" + (status.charAt(0).toUpperCase() + status.slice(1));
            //   statusKey = `CS_COMMON_${status.toUpperCase()}`;
          } else {
            statusKey = "Reassign Requested";
          }
        } else if (status.toLowerCase() == "escalatedlevel1pending") {
          statusKey = " Level 1 Escalation Pending";
        } else if (status.toLowerCase() == "escalatedlevel1assigned") {
          statusKey = "Level 1 Escalation Assigned";
        } else if (status.toLowerCase() == "escalatedlevel2pending") {
          statusKey = "Level 2 Escalation Pending";
        } else if (status.toLowerCase() == "escalatedlevel2assigned") {
          statusKey = "Level 2 Escalation Assigned";
        } else if (status.toLowerCase() == "pendingkmcgroapproval") {
          statusKey = "Pending for KMC GRO Approval";
        } else {
          statusKey = "" + (status.charAt(0).toUpperCase() + status.slice(1));
          //   statusKey = `CS_COMMON_${status.toUpperCase()}`;
        }
      }
      var titleKey = complaint && complaint;
      // const titleKey = complaint && "SERVICEDEFS." + complaint.toUpperCase();

      var prevUrl = (0, _get2.default)(_store2.default.getState().screenConfiguration.preparedFinalObject, "prevUrl", "");

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_components.Card, {
          textChildren: _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: "rainmaker-displayInline" },
              _react2.default.createElement(_components.Icon, { action: "notification", name: "sms-failed", color: "#767676" }),
              " ",
              _react2.default.createElement(_translationNode2.default, { label: "Complaint Details", containerStyle: { marginLeft: "13px" }, labelClassName: "dark-heading" }),
              _react2.default.createElement(_translationNode2.default, {
                label: servicetype == "1" ? "Nagar Bandhu" : servicetype == "0" && prevDept && "Transferred from  " + prevDept + " department",
                containerStyle: { marginLeft: "auto", marginRight: "10px" },
                labelClassName: "dark-heading"
              }),
              process.env.REACT_APP_NAME === "Employee" && _react2.default.createElement(_components.Button, {
                className: "employee-complaint-summary-mapBtn",
                primary: true,
                label: _react2.default.createElement(_translationNode2.default, { buttonLabel: true, label: "Close", color: "#ffffff" }),
                style: {
                  height: "auto",
                  lineHeight: "auto",
                  minWidth: "inherit",
                  backgroundColor: "#5252ff"
                  // padding: "5px 8px 10px 14px",
                }
                //   labelStyle={{
                //     padding: "0 12px 0 0 ",
                //     letterSpacing: "0.6px",
                //     display: "inline-block",
                //     height: "22px",
                //     lineHeight: "22px",
                //   }}
                , onClick: function onClick(e) {
                  if (prevUrl == "/mayor-complaints" || prevUrl == "/employee/mayor-complaints") {
                    (0, _formActionUtils.routeTo)("/mayor-complaints");
                  } else {
                    (0, _formActionUtils.routeTo)("/all-complaints");
                  }
                }
              })
            ),
            _react2.default.createElement(
              "div",
              { key: 10, className: "complaint-detail-full-width" },
              _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-heading rainmaker-big-font", label: category }),
              _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-heading ", label: subCategory }),
              _react2.default.createElement(
                "div",
                { className: "complaint-detail-detail-section-status row" },
                _react2.default.createElement(_translationNode2.default, { className: "col-xs-6  col-sm-4 col-md-2 status-color", label: "Complaint No" }),
                _react2.default.createElement(_translationNode2.default, {
                  labelStyle: { color: "inherit" },
                  className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                  id: "complaint-details-complaint-number",
                  label: applicationNo
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "complaint-detail-detail-section-status row" },
                _react2.default.createElement(_translationNode2.default, { className: "col-xs-6  col-sm-4 col-md-2 status-color", label: "Current Status" }),
                _react2.default.createElement(_translationNode2.default, {
                  className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                  id: "complaint-details-current-status",
                  labelStyle: { color: "inherit" },
                  label: statusKey
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "complaint-detail-detail-section-status row" },
                _react2.default.createElement(_translationNode2.default, { className: "col-xs-6  col-sm-4 col-md-2 status-color", label: "Filed Date" }),
                _react2.default.createElement(_translationNode2.default, {
                  className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                  label: submittedDate,
                  id: "complaint-details-submission-date",
                  labelStyle: { color: "inherit" }
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "complaint-detail-detail-section-status row" },
                _react2.default.createElement(_translationNode2.default, { className: "col-xs-6  col-sm-4 col-md-2 status-color", label: "Source" }),
                _react2.default.createElement(_translationNode2.default, {
                  className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                  label: source && source == "web" ? "Web" : source == "whatsapp" ? "WhatsApp" : source == "talktomayor" ? "Talk To Mayor" : source == "lettertomayor" ? "Letter To Mayor" : source == "voicecallreceipt" ? "Voice Call Receipt" : source == "whatsapptomayor" ? "Whatsapp to Mayor" : source == "cmogrievance" ? "CMO Grievance" : source == "voicecallkmccentre" ? "KMC Call Centre (Voice Call)" : source == "voicecallcontrolroom" ? "KMC Control Room (Voice Call)" : source == "voicecallkmccentreoutreach" ? "Call Centre - OutReach (Voice Call)" : "",
                  id: "complaint-details-submission-date",
                  labelStyle: { color: "inherit" }
                })
              ),
              description && _react2.default.createElement(
                "div",
                { className: "complaint-detail-detail-section-status row" },
                _react2.default.createElement(_translationNode2.default, { className: "col-xs-6  col-sm-4 col-md-2 status-color", label: "Additional Details" }),
                _react2.default.createElement(_translationNode2.default, {
                  className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                  label: description,
                  id: "complaint-details-submission-date",
                  labelStyle: { color: "inherit" }
                })
              ),
              _react2.default.createElement(
                "div",
                { style: { marginTop: "16px", display: "none" }, className: "complaint-image-cont" },
                images && images.map(function (image, index) {
                  return image && _react2.default.createElement(
                    "div",
                    { className: "complaint-image-wrapper", key: index },
                    _react2.default.createElement(_components.Image, {
                      style: imageStyles,
                      size: "medium",
                      className: "complaint-image",
                      width: "100%",
                      height: 46,
                      source: image,
                      onClick: function onClick() {
                        return _this2.onImageClick(image);
                      }
                    })
                  );
                })
              ),
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "div",
                  null,
                  addressDetail && !(0, _isEmpty2.default)(addressDetail) && _react2.default.createElement(
                    "div",
                    { className: "rainmaker-displayInline" },
                    _react2.default.createElement(_components.Icon, { className: "map-icon", action: "maps", name: "place", style: { marginRight: 13 }, color: "#767676" }),
                    _react2.default.createElement(_translationNode2.default, { label: "Location Of Grievance", labelClassName: "dark-heading" })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "complaint-detail-detail-section-status row", style: { paddingLeft: "40px" } },
                    _react2.default.createElement(_translationNode2.default, {
                      label: premise,
                      className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                      id: "complaint-details-complaint-location",
                      labelStyle: { color: "inherit" }
                    }),
                    _react2.default.createElement(_translationNode2.default, {
                      label: streetName + ", Ward: " + ward + ",",
                      className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                      id: "complaint-details-complaint-location",
                      labelStyle: { color: "inherit" }
                    }),
                    _react2.default.createElement(_translationNode2.default, {
                      label: address + ", " + pincode + ",",
                      className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                      id: "complaint-details-complaint-location",
                      labelStyle: { color: "inherit" }
                    }),
                    _react2.default.createElement(_translationNode2.default, {
                      label: landmark,
                      className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                      id: "complaint-details-complaint-location",
                      labelStyle: { color: "inherit" }
                    })
                  )
                )
              ),
              houseNoAndStreetName && _react2.default.createElement(
                "div",
                { className: "complaint-detail-detail-section-status row" },
                _react2.default.createElement(_translationNode2.default, { className: "col-xs-6  col-sm-4 col-md-2 status-color", label: "House/Street No", id: "complaint-details-complaint-location" }),
                _react2.default.createElement(_translationNode2.default, {
                  label: houseNoAndStreetName,
                  className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                  id: "complaint-details-complaint-location",
                  labelStyle: { color: "inherit" }
                })
              ),
              mohalla && city && _react2.default.createElement(
                "div",
                { className: "complaint-detail-detail-section-status row" },
                _react2.default.createElement(_translationNode2.default, { className: "col-xs-6  col-sm-4 col-md-2 status-color", label: "WARD", id: "complaint-details-complaint-location" }),
                _react2.default.createElement(
                  "div",
                  { className: "col-xs-6  col-sm-8 col-md-10 no-padding complaint-address-display" },
                  _react2.default.createElement(_translationNode2.default, {
                    label: locality,
                    className: "status-result-color",
                    id: "complaint-details-complaint-location",
                    labelStyle: { color: "inherit" }
                  }),
                  _react2.default.createElement(_translationNode2.default, {
                    label: ",",
                    className: "comma-style",
                    id: "complaint-details-complaint-location",
                    labelStyle: { color: "inherit" },
                    fontSize: "16px"
                  }),
                  _react2.default.createElement(_translationNode2.default, {
                    label: "TENANT_TENANTS_" + city.toUpperCase().replace(/[.]/g, "_"),
                    className: "status-result-color",
                    id: "complaint-details-complaint-location",
                    labelStyle: { color: "inherit" }
                  })
                )
              ),
              address && (0, _isEmpty2.default)(addressDetail) && _react2.default.createElement(
                "div",
                { className: "rainmaker-displayInline" },
                _react2.default.createElement(_components.Icon, { className: "map-icon", action: "maps", name: "place", style: { marginRight: "13px" }, color: "#767676" }),
                _react2.default.createElement(_translationNode2.default, {
                  label: address,
                  className: "status-result-color",
                  id: "complaint-details-complaint-location",
                  labelStyle: { color: "inherit" }
                })
              ),
              addressDetail && !(0, _isEmpty2.default)(addressDetail) && residenceAddress && _react2.default.createElement(
                "div",
                { className: "rainmaker-displayInline" },
                _react2.default.createElement(_translationNode2.default, { label: "Residential Address", labelStyle: { marginLeft: "23px" }, labelClassName: "dark-heading" })
              ),
              addressDetail && !(0, _isEmpty2.default)(addressDetail) && residenceAddress && _react2.default.createElement(
                "div",
                { className: "rainmaker-displayInline" },
                _react2.default.createElement(_translationNode2.default, { label: "" + residenceAddress, labelStyle: { marginLeft: "23px" }, className: "status-result-color" })
              ),
              _react2.default.createElement(
                "div",
                null,
                " ",
                _react2.default.createElement(_translationNode2.default, { label: "Citizen Details", labelClassName: "dark-heading", labelStyle: { marginLeft: "23px" } }),
                " ",
                _react2.default.createElement(_translationNode2.default, {
                  label: fullName,
                  className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                  id: "complaint-details-complaint-location",
                  labelStyle: { marginLeft: "23px" }
                }),
                " ",
                _react2.default.createElement(_translationNode2.default, {
                  label: phone,
                  className: "col-xs-6  col-sm-8 col-md-10 no-padding status-result-color",
                  id: "complaint-details-complaint-location",
                  labelStyle: { marginLeft: "23px" }
                })
              )
            )
          )
        })
      );
    }
  }]);
  return Details;
}(_react.Component);

exports.default = Details;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/pgr/complaintDetails/components/Details/index.js
// module id = 3382
// module chunks = 1137